import PropTypes from 'prop-types';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ModuleNavigationStatement = ({
    nextModuleType,
    previousModuleType,
    sidebarTitle,
    statement,
}) => {

    return (
        <div className= {`${nextModuleType === 'LandscapeMedia' && previousModuleType === 'FundCards' ? 'pt-100 pb-60 sm:pt-90 sm:pb-70 md:pt-125 md:pb-125' : 'py-100'} layout-container-padding-right flex flex-wrap max-w-container`}>
            {/* Left Sidebar */}
            <div className='w-sidebar pt-10'>
                <div className='flex flex-col items-center'>
                    <h2 className='type-style-8 inline-block align-middle rotate-180 writing-mode-vertical-rl'>
                        {sidebarTitle}
                    </h2>
                </div>
            </div>
            {/* Body */}
            <div className='flex-1 layout-negative-margin'>
                <section className='layout-item-padding'>
                    <div
                        className='rich-text font-normal type-style-3 sm:type-style-2 sm:font-normal -mt-[13px] md:-mt-15'
                        dangerouslySetInnerHTML={{__html: statement }}/>
                </section>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    nextModuleType: PropTypes.string,
    previousModuleType: PropTypes.string,
    sidebarTitle: PropTypes.string,
    statement: PropTypes.string.isRequired,
};


ModuleNavigationStatement.propTypes = propTypes;

export default ModuleNavigationStatement;
